import { document_update } from './document_update';

export class document_update_request {
  password:string;
  documentUpdates:document_update[];
}
